export function getIngestionAlertSeverity(
  status: string
): "success" | "error" | "warning" | "info" {
  if (status === "SUCCEEDED") return "success";
  if (status.startsWith("FAILED")) return "error";
  if (status === "QUEUED") return "warning";
  return "info";
}

export function getIngestionStatusColor(
  status: string | null | undefined
): "success" | "error" | "warning" | "info" | "default" {
  if (!status) return "default";
  if (status === "SUCCEEDED") return "success";
  if (status.startsWith("FAILED")) return "error";
  if (status === "RUNNING" || status === "DISPATCHED") return "info";
  if (status === "QUEUED") return "warning";
  return "default";
}
